import { Colors } from '@/common/colors/colors';

export const getBellColor = (seenStatus) =>
	seenStatus ? Colors.red : Colors.darkBlue;
